import React, { useContext } from 'react';
import { Context } from '../../../StoreLocator/Context/StoreLocatorContext';
import { InventoryLabels, Offer } from '../../../../ContentfulTypes';
import { NearbyStore } from '../../../../types';
import {
  ReservationBladeBadge,
  ProductDetailBadge,
} from './VariantInventoryBadges';

interface InventoryBadgesProps {
  activeStore?: NearbyStore;
  inventoryLabels?: InventoryLabels;
  page?: string;
  apiError?: boolean;
  inventoryStatus?: string;
  selectedCarrier?: string;
  selectedSKU?: string;
  offer?: Offer | null;
}

const InventoryBadges = ({
  activeStore,
  inventoryLabels,
  page,
  apiError = false,
  inventoryStatus = '',
  selectedCarrier = '',
  selectedSKU = '',
  offer = null,
}: InventoryBadgesProps) => {
  const { bladeState, setBladeState } = useContext(Context);

  const handleClick = () => {
    setBladeState(!bladeState);
    const gtmData = {
      event: "carrierTier",
      carrierAndPhone: offer?.cmsName,
      carrierAction: "Change store",
    };
    window.dataLayer.push(gtmData);
  };

  const badges = inventoryLabels?.inventoryStatus?.filter(
    ({ inventoryStatusCode }) => inventoryStatusCode === inventoryStatus,
  );

  if (!page || page === 'accessoryProductDetail') {
    return (
      <ProductDetailBadge
        activeStore={activeStore}
        inventoryLabels={inventoryLabels}
        handleClick={handleClick}
        badges={badges}
        page={page}
        apiError={apiError}
        inventoryStatus={inventoryStatus}
        offer={offer}
      />
    );
  }
  return (
    <ReservationBladeBadge
      activeStore={activeStore}
      inventoryLabels={inventoryLabels}
      badges={badges}
      page={page}
      selectedCarrier={selectedCarrier}
      selectedSKU={selectedSKU}
      apiError={apiError}
    />
  );
};

export default InventoryBadges;
